<div class="container bg-header">
  <div class="row">
    <div class="col-6">
      <h1 mat-dialog-title class="text-white p-3 m-0">{{'modals.modal.your-organization.title' | translate}}</h1>
    </div>
    <div class="col-6 d-flex justify-content-end align-items-center">
      <p (click)="closeDialogue()" class="text-white m-0">{{'generic.cancel' | translate}}</p>
      <mat-icon class="ml-1" (click)="closeDialogue()">cancel</mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content class="m-3">
  <div class="org-cards-wrapper">
    @for (organization of getUserService().getAllOrganizations(); track organization; let i = $index) {
      <mat-card class="org-card-compact" [ngClass]="{'org-card-current': getUserService().currentOrganization.id === organization.id}" (click)="changeCurrentOrganization(organization.id)" [routerLink]="['/home']">
        <div class="org-card-content">
          <img [src]="organization?.logo_link || 'assets/img/placeholder-img-organization.jpg'"
            (error)="$any($event.target).src='assets/img/placeholder-img-organization.jpg'"
            [ngClass]="getUserService().currentOrganization.id === organization.id ? 'border-custom' : ''"
            class="org-logo-small" alt="">
          <p class="org-name">{{organization.name}}</p>
          @if (organization?.roles?.length) {
            <p class="org-role-label">{{'generic.roles.role' | translate}}</p>
            <p class="org-role">
              @for (orgRole of organization.roles; track orgRole; let last = $last) {
                {{orgRole?.role?.role}}{{last ? '' : ', '}}
              }
            </p>
          }
        </div>
        <div class="org-card-footer">
          @if (getUserService().currentOrganization.id === organization.id) {
            <mat-icon class="org-footer-icon">check_circle</mat-icon>
            <span>{{'general.current' | translate}}</span>
          } @else {
            <mat-icon class="org-footer-icon">touch_app</mat-icon>
            <span>{{'general.select' | translate}}</span>
          }
        </div>
      </mat-card>
    }
  </div>
</div>
<div mat-dialog-actions align="center" class="dialog-actions-buttons">
  <button mat-stroked-button class="text-dark-purple border-purple" (click)="closeDialogue()">
    {{ 'generic.buttons.back' | translate }}
  </button>
</div>
